// extracted by mini-css-extract-plugin
export var logo = "_4q-2";
export var logoWrapper = "_4q-1";
export var strip = "_4q-0";